// extracted by mini-css-extract-plugin
export default {"detail":"DetailCard_detail__ulVua","header":"DetailCard_header__Zj+3I","headerLabel":"DetailCard_headerLabel__n6xi6","secondaryText":"DetailCard_secondaryText__WZcC3"};